import React, { useState } from 'react';

import TextInputLabelOff from '../Common/Input/TextInputLabelOff';
import BaseModal from '../Common/Modal/BaseModal';
import { formatNumber, formatPrice } from '@/utils/common';

export interface ActualSalePriceInputPopupProps {
  isShow: boolean;
  setIsShow: React.Dispatch<React.SetStateAction<boolean>>;
  placeholder: string;
  price?: number;
  /** 확인 시 (actualSalePrice는 부모 state, completeReason은 인자로 전달) */
  onClickOk: (completeReason: string) => void;
  inputValue: number | undefined;
  setInputValue: React.Dispatch<React.SetStateAction<number | undefined>>;
  useErrorMessage?: boolean;
}

const ActualPriceModal = ({
  isShow,
  setIsShow,
  placeholder,
  price,
  onClickOk,
  inputValue,
  setInputValue,
  useErrorMessage = true,
}: ActualSalePriceInputPopupProps) => {
  const [actualSalePriceError, setActualSalePriceError] = useState(false);
  const [actualSalePriceErrorMessage, setActualSalePriceErrorMessage] = useState('');
  const [review, setReview] = useState('');
  const [reviewError, setReviewError] = useState(false);

  const onChangeActualSalePrice = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;

    let price = String(value).replace(/[^0-9.]/g, '');
    if (/^[0-9]*$/.test(price) || price === '0') {
      if (Number(price) >= 100000) {
        price = String(99999);
      } else {
        setInputValue(Number(price));
      }
    }
    setInputValue(Number(price));
  };

  const onClickOkBtn = () => {
    const trimmedReview = review.trim();
    if (!trimmedReview) {
      setReviewError(true);
      return;
    }
    if (inputValue || !useErrorMessage) {
      setReviewError(false);
      onClickOk(trimmedReview);
      closePopup();
    } else {
      setActualSalePriceError(true);
      setActualSalePriceErrorMessage(`${placeholder}을 입력해주세요.`);
    }
  };

  const closePopup = () => {
    setIsShow(false);
    setActualSalePriceError(false);
    setActualSalePriceErrorMessage('');
    setReviewError(false);
    setReview('');
    setInputValue(undefined);
  };

  return (
    <>
      <BaseModal
        isOpen={isShow}
        onClose={closePopup}
        title="<span class='font-medium text-[20px] sm280:text-[16px]'>판매 완료로 변경되었어요</span>"
        content={
          <div className="px-[10px]">
            <p className="text-[18px] sm280:text-[14px] mb-[24px]">실제 판매 금액을 입력해주세요.</p>
            <TextInputLabelOff
              name="actualPrice"
              placeholder={placeholder}
              value={(inputValue && formatNumber(String(inputValue), false)) || ''}
              height={36}
              fontSize={17}
              onChange={onChangeActualSalePrice}
              error={useErrorMessage && actualSalePriceError}
              errorMsg={actualSalePriceErrorMessage}
              inputMode="numeric"
              suffix="만원"
              autoFocus
            />
            {!actualSalePriceError && (
              <div className="text-left pt-[6px] text-gray-7 text-[16px] sm280:text-[14px]">
                {price && <>기존 금액 [{formatPrice(String(price))}]</>}
              </div>
            )}

            <div className="mt-6">
              <p className={`text-[16px] font-medium mb-2 text-left ${reviewError ? 'text-red' : 'text-gray-11'}`}>
                직트럭 후기
                <span className="text-red ml-1">(필수)</span>
              </p>
              <div
                className={`w-full rounded-xl border px-3 py-2 focus-within:border-primary-10 ${reviewError ? 'border-red bg-gray-1' : 'border-gray-2 bg-gray-1'}`}
              >
                <textarea
                  className="w-full h-[90px] bg-transparent text-[14px] text-gray-8 placeholder:text-gray-5 focus:outline-none resize-none"
                  placeholder={`판매 경험에 대한 자세한 후기를 남겨주세요.\n직트럭 APP 개선에 도움이됩니다.`}
                  maxLength={200}
                  value={review}
                  onChange={(e) => {
                  setReviewError(false);
                  setReview(e.target.value);
                }}
                />
              </div>
              <div className="mt-1 text-right text-[12px] text-gray-7">{review.length} / 200자</div>
            </div>
          </div>
        }
        leftButtonLabel="취소"
        rightButtonLabel="확인"
        onLeftButtonClick={closePopup}
        onRightButtonClick={onClickOkBtn}
        paddingType="padding-top-32"
      />
    </>
  );
};

export default ActualPriceModal;
